<template>
  <div
    class="ds-user-avatar"
    :class="[colorClass, sizeClass, fallbackClass]"
  >
    <img
      v-if="visiblePhoto"
      :src="visiblePhoto"
      draggable="false"
      class="w-full select-none"
      :alt="alt ?? 'Profile picture'"
      @error="failedPhoto = visiblePhoto"
    >
    <span
      v-else-if="initial"
      role="img"
      :aria-label="alt ?? 'Profile picture'"
    >{{ initial }}</span>
    <img
      v-else
      width="48"
      height="48"
      :src="GUEST_AVATAR_PATH"
      draggable="false"
      class="w-full select-none"
      :alt="alt ?? 'Profile picture'"
    >
  </div>
</template>

<script>
import { GUEST_AVATAR_PATH } from '@/modules/misc/common/navbar/config.json';

export default {
  name: 'UserAvatar',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    photo: {
      type: String,
    },
    // eslint-disable-next-line vue/require-default-prop
    initial: {
      type: String,
    },
    color: {
      type: String,
      validator(color) {
        return ['grey', 'green', 'dark-green'].indexOf(color) !== -1;
      },
      default: 'grey',
    },
    alt: {
      type: String,
      default: 'Profile picture',
    },
    size: {
      type: String,
      validator(size) {
        return ['large', 'medium', 'small'].indexOf(size) !== -1;
      },
      default: 'medium',
    },
  },
  data() {
    return {
      GUEST_AVATAR_PATH,
      failedPhoto: null,
    };
  },
  computed: {
    visiblePhoto() {
      return this.photo && this.photo !== this.failedPhoto ? this.photo : null;
    },
    sizeClass() {
      return {
        large: 'ds-user-avatar--large',
        medium: '',
        small: 'ds-user-avatar--small',
      }[this.size];
    },
    colorClass() {
      if (this.color === 'dark-green' && (this.visiblePhoto || !this.initial)) {
        return '';
      }

      return {
        green: 'ds-user-avatar--green',
        grey: 'ds-user-avatar--grey',
        'dark-green': 'ds-user-avatar--dark-green',
      }[this.color];
    },
    fallbackClass() {
      return !this.visiblePhoto && !this.initial
        ? 'ds-user-avatar--fallback'
        : '';
    },
  },
};
</script>

<style lang="scss">
@use "@sass/design-system/avatar";
</style>
